/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
/* eslint-disable sort-keys */
import {Sandbox} from '@exc/core';

export default {
  appId: 'jaeger-3rd',
  distributionList: ['Grp-CNA'],
  name: 'jaeger-3rd',
  path: '/myapps/:id',
  serviceCode: '',
  sandbox: {
    history: Sandbox.HISTORY_TYPES.HISTORY,
    sources: {
      dev: {discovery: 'https://localhost.corp.adobe.com:12310/discovery-cna'},
      qa: {discovery: 'https://53444_51636.adobeioruntime.net/api/v1/web/aio-app-myapps-0.0.3/resolver'},
      stage: '',
      prod: ''
    },
    thirdParty: true
  },
  access: []
};
